<template>
  <Modal v-model="isVisible" width="lg">
    <div slot="header">
      Indicar Condutor
    </div>

    <p class="my-2">
      Selecione um motorista existente ou cadastre um novo motorista para indicar como condutor responsável.
    </p>

    <div class="form-group">
      <label>Motorista</label>
      <select
        v-model="selectedDriverCpf"
        class="browser-default custom-select"
      >
        <option value="">Selecione um motorista</option>
        <option
          v-for="option in driverOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <button
        @click="openDriverForm"
        class="btn btn-outline btn-sm"
      >
        + Cadastrar Motoristas
      </button>
    </div>

    <template slot="footer">
      <button @click="close" class="btn btn-outline mr-2">Cancelar</button>
      <button
        @click="indicateExistingDriver"
        class="btn btn-primary"
        :disabled="!selectedDriverCpf"
      >
        Indicar Motorista Selecionado
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/shares/specialTag/Modal'

export default {
  components: { Modal },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {
    this.loadDrivers()
  },
  data: () => ({
    drivers: [],
    driverOptions: [],
    selectedDriverCpf: ''
  }),
  methods: {
    close() {
      this.isVisible = false
      this.resetForm()
    },
    indicateExistingDriver() {
      if (this.selectedDriverCpf) {
        const selectedDriver = this.drivers.find(d => d.cpf === this.selectedDriverCpf)
        if (selectedDriver) {
          this.$emit('confirmDriver', selectedDriver)
        }
      }
    },
    loadDrivers() {
      const uniqueCpfs = [...new Set(this.selectedTickets.map(t => t.cpf).filter(Boolean))]

      const hasTicketWithoutDriver = this.selectedTickets.some(t => !t.cpf)

      this.loadDriversFromBackend(hasTicketWithoutDriver ? null : uniqueCpfs)
    },
    loadDriversFromBackend(uniqueCpfs) {
      const params = {
        meta: false,
        per_page: 10000
      }

      if (uniqueCpfs && uniqueCpfs.length > 0) {
        params.q = { cpf: uniqueCpfs }
      }

      this.axios.get('drivers', { params })
        .then(response => {
          this.drivers = response.data
          this.buildDriverOptions()
        })
        .catch(e => {
          this.$notify.addError(e)
          this.drivers = []
          this.driverOptions = []
        })
    },
    buildDriverOptions() {
      const sortedDrivers = [...this.drivers].sort((a, b) => {
        const nameCompare = (a.name || '').localeCompare(b.name || '', 'pt-BR', { sensitivity: 'base' })
        if (nameCompare !== 0) return nameCompare
        return (a.cpf || '').localeCompare(b.cpf || '')
      })

      this.driverOptions = sortedDrivers.map(driver => {
        const cpfFormatted = driver.cpf
          ? driver.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
          : ''
        return {
          label: `${driver.name} - ${cpfFormatted}`,
          value: driver.cpf
        }
      })
    },
    openDriverForm() {
      this.$emit('openDriverForm')
    },
    reloadDrivers() {
      this.loadDrivers()
    },
    resetForm() {
      this.selectedDriverCpf = ''
    }
  },
  name: 'DriverSelectionModal',
  props: {
    value: { required: true, type: Boolean },
    selectedTickets: { required: true, type: Array }
  },
  watch: {
    selectedTickets: {
      handler() {
        this.loadDrivers()
      },
      deep: true
    },
    value(newVal) {
      if (newVal) {
        this.loadDrivers()
      }
    }
  }
}
</script>

<style scoped>
</style>
